import { gql } from '@apollo/client';

export const DELETE_PATIENT_ATTACHMENT = gql`
  query deletePatientAttachment($data: String!) {
    deletePatientAttachment(data: $data)
  }
`;
